// Page « module à venir » (E1a) — les items de nav du shell (mock figé : Résultats
// financiers, Équipes, Organigramme, Affichages, Rencontres CG) existent dès E1a
// mais leurs écrans arrivent aux frags suivants. Une route honnête avec EmptyState
// explicite vaut mieux qu'un item de nav qui redirige silencieusement vers /.
import { PageHeader, EmptyState } from '@gs/ui';
import { Hourglass } from 'lucide-react';
import { useTranslation } from '../i18n';

export interface ComingSoonPageProps {
  /** Clé du module (gest:modules.{key}.title/description). */
  moduleKey: 'teams' | 'meetings' | 'pulse' | 'finance' | 'compensation' | 'publications' | 'org' | 'postings';
}

export default function ComingSoonPage({ moduleKey }: ComingSoonPageProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <PageHeader
        title={t(`gest:modules.${moduleKey}.title`)}
        description={t(`gest:modules.${moduleKey}.description`)}
      />
      <EmptyState
        title={t('gest:accueil.comingSoon.title')}
        description={t('gest:accueil.comingSoon.description')}
        icon={<Hourglass size={40} className="text-slate-300 dark:text-slate-600" aria-hidden />}
      />
    </div>
  );
}
